import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "scrollable-container" }
const _hoisted_2 = { class: "d-flex align-center" }
const _hoisted_3 = { class: "expanded-row" }
const _hoisted_4 = { class: "d-flex flex-column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_data_table = _resolveComponent("v-data-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.hideTopDivider)
      ? (_openBlock(), _createBlock(_component_v_divider, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_data_table, {
        "sort-by": _ctx.sortingBy,
        "onUpdate:sortBy": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.sortingBy) = $event)),
        headers: _ctx.headers,
        items: _ctx.items,
        "items-per-page-text": _ctx.footerOptions['items-per-page-text'],
        "items-per-page-options": _ctx.footerOptions['items-per-page-options'],
        "show-first-last-page": _ctx.footerOptions['show-first-last-page'],
        loading: _ctx.isLoading,
        "loading-text": _ctx.t('loading'),
        "no-data-text": _ctx.t('no_data_available'),
        "single-expand": true,
        "items-per-page": _ctx.itemsPerPageDefault,
        page: _ctx.currentPage,
        "checkbox-color": "primary",
        "show-select": false,
        "hide-default-footer": _ctx.disablePagination,
        "show-expand": "",
        "onUpdate:page": _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateCurrentPage($event)))
      }, {
        "header.data-table-select": _withCtx(() => [
          _createVNode(_component_v_checkbox, {
            "hide-details": "",
            class: "mt-0 pa-0"
          })
        ]),
        "item.count": _withCtx(({ value }) => [
          _createElementVNode("div", _hoisted_2, [
            _createTextVNode(_toDisplayString(value) + " ", 1),
            _createVNode(_component_v_tooltip, {
              text: _ctx.t('station_table.combined_stations_tooltip'),
              "open-delay": 200,
              right: "",
              "nudge-bottom": 35,
              "content-class": "station-hint",
              "data-testid": "tooltip-combined-stations-simple"
            }, {
              activator: _withCtx(({ props }) => [
                _createVNode(_component_v_icon, _mergeProps(props, {
                  "data-testid": "tooltip-combined-stations-simple-icon",
                  style: value <= 1 && { visibility: 'hidden' },
                  color: "primary",
                  size: "x-small"
                }), {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode(" mdi-help ", -1)
                  ]))]),
                  _: 1
                }, 16, ["style"])
              ]),
              _: 2
            }, 1032, ["text"])
          ])
        ]),
        "item.startDate": _withCtx(({ value }) => [
          _createTextVNode(_toDisplayString(_ctx.cleanDate(value)), 1)
        ]),
        "item.endDate": _withCtx(({ value }) => [
          _createTextVNode(_toDisplayString(_ctx.cleanDate(value)), 1)
        ]),
        "item.state": _withCtx(({ value }) => [
          _createTextVNode(_toDisplayString(_ctx.cleanState(value)), 1)
        ]),
        "item.hasSunshine": _withCtx(({ value }) => [
          _createTextVNode(_toDisplayString(_ctx.cleanBoolean(value)), 1)
        ]),
        "item.hasGlobalRadiation": _withCtx(({ value }) => [
          _createTextVNode(_toDisplayString(_ctx.cleanBoolean(value)), 1)
        ]),
        "item.data-table-expand": _withCtx(({ internalItem, isExpanded, toggleExpand }) => [
          _createVNode(_component_v_btn, {
            icon: "",
            variant: "flat",
            style: _normalizeStyle(internalItem.raw.type !== 'COMBINED' && { visibility: 'hidden' }),
            onClick: ($event: any) => (toggleExpand(internalItem))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                icon: isExpanded(internalItem) ? 'mdi-chevron-up' : 'mdi-chevron-down'
              }, null, 8, ["icon"])
            ]),
            _: 2
          }, 1032, ["style", "onClick"])
        ]),
        "expanded-row": _withCtx(({ item }) => [
          _createElementVNode("tr", _hoisted_3, [
            _cache[4] || (_cache[4] = _createElementVNode("td", { colspan: 1 }, null, -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headerNames, (key) => {
              return (_openBlock(), _createElementBlock("td", {
                key: key,
                class: "pa-0"
              }, [
                _createElementVNode("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.subStations, (station) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: station.id,
                      class: _normalizeClass(
                    'substation-row d-flex px-4 align-center' +
                      (_ctx.stationIsDisabled(station) ? ' zamg-text-disabled' : '')
                  )
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.cleanSubstationValue(station[key])) + " ", 1),
                      (_ctx.stationIsDisabled(station) && key === 'count')
                        ? (_openBlock(), _createBlock(_component_v_tooltip, {
                            key: 0,
                            text: `${station.name} (${station.id}) ${_ctx.t(
                      'station_table.combined_station_not_matched'
                    )}`,
                            "open-delay": 200,
                            right: "",
                            "nudge-bottom": 35,
                            "content-class": "station-hint"
                          }, {
                            activator: _withCtx(({ props }) => [
                              _createVNode(_component_v_icon, _mergeProps({ ref_for: true }, props, {
                                color: "primary",
                                size: "x-small"
                              }), {
                                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                  _createTextVNode(" mdi-help ", -1)
                                ]))]),
                                _: 1
                              }, 16)
                            ]),
                            _: 1
                          }, 8, ["text"]))
                        : _createCommentVNode("", true)
                    ], 2))
                  }), 128))
                ])
              ]))
            }), 128))
          ])
        ]),
        "footer.page-text": _withCtx((item) => [
          _createTextVNode(_toDisplayString(`${item.pageStart} - ${item.pageStop} ${_ctx.t('of')} ${_ctx.items.length}`), 1)
        ]),
        _: 1
      }, 8, ["sort-by", "headers", "items", "items-per-page-text", "items-per-page-options", "show-first-last-page", "loading", "loading-text", "no-data-text", "items-per-page", "page", "hide-default-footer"])
    ])
  ]))
}